import { Box } from '../Box';
import { styled } from '../../theme';

interface Props {
    elevation?: number;
}

export const FixedPageHeader = ({ children, elevation = 0 }: React.PropsWithChildren<Props>) => {
    return (
        <BoxStyled component="header" elevation={elevation}>
            {children}
        </BoxStyled>
    );
};

interface BoxProps {
    elevation: number;
}

const BoxStyled = styled(Box, { shouldForwardProp: (prop) => prop !== 'elevation' })<BoxProps>(
    ({ theme, elevation }) => ({
        position: 'fixed',
        zIndex: theme.zIndex.drawer + 1,
        boxShadow: theme.shadows[elevation],
        left: 0,
        right: 0,
        width: '100%',
    }),
);
